import React from 'react';
import styled from 'styled-components';
import { colors } from 'helpers/ColorHelper';
import { MdChevronRight as ChevronRightIcon } from 'react-icons/md';

const StyledCard = styled.div`
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.125);
  border-radius: 8px;
  width: 100%;
  padding: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 15px;
  align-items: center;
  background: white;
`;

const StyledLeft = styled.div`
  display: flex;
  align-items: center;
`;

const StyledInitials = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  font-size: 24px;
  color: #fff;
  line-height: 55px;
  text-align: center;
  background: ${(props) => (props.color ? props.color : 'red')};
  margin-right: 24px;
`;

const StyledName = styled.p`
  margin: 0px;
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
`;

const StyledRightA = styled.a`
  color: ${colors.ULTRAMARINE_BLUE};
`;

const ResidentCard = ({ resident }) => (
  <StyledCard>
    <StyledLeft>
      <StyledInitials color={resident.color}>
        {`${resident.first_name[0]}${resident.last_name[0]}`}
      </StyledInitials>
      <StyledName>{`${resident.first_name} ${resident.last_name}`}</StyledName>
    </StyledLeft>
    <div>
      <StyledRightA href={`/companies/tenants?tenantId=${resident.id}`} target="_blank">
        <ChevronRightIcon size={24} style={{ padding: 0 }} />
      </StyledRightA>
    </div>
  </StyledCard>
);

export default ResidentCard;
